import React, { ReactNode } from "react";

interface ITaskDynamicFormTableContainerProps {
    mobile?: boolean;
    children: ReactNode;
}

export const TaskDynamicFormTableContainer = (props: ITaskDynamicFormTableContainerProps) => (
    <div className={"jsonFormLineData" + (props.mobile ? " mobileSimulation" : "")} style={{ marginTop: "1.5rem" }}>
        {props.children}
    </div>
);
